"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Page = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactResponsive = require("react-responsive");
var _utils = require("../../../utils");
var _ui = require("../../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Page = function Page(_ref) {
  var tabsNav = _ref.tabsNav,
    userCard = _ref.userCard,
    TabsContent = _ref.tabsContent;
  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    minWidth: _utils.breakpoints.md
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ui.Card, null, /*#__PURE__*/_react.default.createElement(_ui.CardBody, null, !isDesktop && tabsNav, /*#__PURE__*/_react.default.createElement(_ui.Row, null, /*#__PURE__*/_react.default.createElement(_ui.Col, {
    xs: 12,
    md: "auto"
  }, userCard), /*#__PURE__*/_react.default.createElement(_ui.Col, {
    className: "d-flex flex-column",
    xs: 12,
    md: ""
  }, isDesktop && tabsNav, /*#__PURE__*/_react.default.createElement(TabsContent, {
    className: "d-flex flex-grow-1"
  }))))));
};
exports.Page = Page;